import { parseJwt } from 'utils/helpers';

export const validateTrustedToken = (token: string): boolean => {
  try {
    const tokenSplited = token.split('.');
    tokenSplited[1] = [
      tokenSplited[1].slice(0, 5),
      tokenSplited[1].slice(9),
    ].join('');

    const tokenCleaned = tokenSplited.join('.');

    parseJwt(tokenCleaned);

    return true;
  } catch (error) {
    return false;
  }
};
